import React, { useEffect, useState, useContext } from "react";
import { Box, FormControl, Button, Link, Typography } from "@mui/material";
import PageTitle from "../../common/PageTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import { getAPI, postAPI, patchAPI, deleteAPI } from "../../network";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { Select as Choice } from '@mui/material';
import { toast } from 'react-toastify';
import { CompanyContext } from '../../../context';
import "./style.css";
import { formatDate, validation, tableHeader, tableData } from "../../utils";
import Loader from "../../common/Loader";
import EmptyTable from "../../common/EmptyTable";
import UploadFileIcon from '@mui/icons-material/UploadFile';
// ✅ react-select removed


export default function Vendor() {

  let companyId = localStorage.getItem('companyIdLS');
  if (companyId === null) {
    companyId = undefined;
  }

  const [open, setOpen] = useState(false);
  const [user, setUser] = useState('');
  const [editId, setEditId] = useState('');
  const [action, setAction] = useState('');
  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [roles, setRoles] = useState([]);
  const [company, setCompany] = useState([]);
  const [sites, setSites] = useState([]);
  const [page, setPage] = useState(0);

  const [permissionList, setPermissionList] = useState([]);

  useEffect(() => {
    const permissions = JSON.parse(localStorage.getItem("permisionlist")) || [];
    setPermissionList(permissions);
  }, []);

  const submenuPermissions = permissionList[0]?.submenuPermissions || [];

  const canAdd = submenuPermissions.some(
    (permission) => permission.submenu === "Add"
  );
  const canEdit = submenuPermissions.some(
    (permission) => permission.submenu === "Edit"
  );
  const canDelete = submenuPermissions.some(
    (permission) => permission.submenu === "Delete"
  );
  const showBothButtons = submenuPermissions.length === 0;

  const toastObj = { position: toast.POSITION.TOP_CENTER };

  const [person, setPerson] = useState({
    name: '',
    email: '',
    phone: '',
    countryId: '',
    cityId: '',
    address: '',
    role: '',
    company: '',
    site: [],          // ✅ array of plain ID strings
    mLicense: '',
    nameError: false,
    emailError: false,
    phoneError: false,
    countryIdError: false,
    cityIdError: false,
    addressError: false,
    roleError: false,
    companyError: false,
    siteError: false,
    mLicenseError: false
  });

  const [perPages] = useState([10, 25, 50]);
  const [perPage, setPerPage] = useState(10);
  const [selectedFile, setSelectedFile] = useState(null);
  const [message, setMessage] = useState('');


  useEffect(() => {
    getVendors();
    getCountries();
    getRoles();
    getCompany();
    getSites();
  }, []);


  const getVendors = async () => {
    const url = companyId ? `/vendors?company=${companyId}` : `/vendors`;
    setLoader(true);
    let data = await getAPI(url);
    if (data) {
      setVendors(data);
    }
    setLoader(false);
  };

  const getCities = async (countryId) => {
    setLoader(true);
    const data = await getAPI(`/cities/by-country/${countryId}`);
    if (data) {
      setCities(data);
    }
    setLoader(false);
  };

  const getRoles = async () => {
    setLoader(true);
    const data = await getAPI('/adm/roles');
    if (data) {
      setRoles(data);
    }
    setLoader(false);
  };

  const getCompany = async () => {
    setLoader(true);
    const data = await getAPI('/companies');
    if (data) {
      setCompany(data);
    }
    setLoader(false);
  };

  const getSites = async () => {
    setLoader(true);
    const url = companyId ? `/sites?companyId=${companyId}` : `/sites`;
    const data = await getAPI(url);
    if (data) {
      let outputs = data.map((item) => ({
        id: item._id,
        label: item.name,
        value: item._id
      }));
      setSites(outputs);
    }
    setLoader(false);
  };

  const getCountries = async () => {
    setLoader(true);
    const data = await getAPI('/countries');
    if (data) {
      setCountries(data);
    }
    setLoader(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPerPage(event.target.value);
    setPage(0);
  };

  const addVendor = (e) => {
    e.preventDefault();
    setAction('add');
    clearAll();
    setOpen(true);
  };

  const editVendor = (e, id) => {
    e.preventDefault();
    setEditId(id);
    clearAll();

    // ✅ Fix #7: safe lookup using _id || id
    let data = vendors.find(item => (item._id || item.id) === id);

    // ✅ Fix #2: pre-fill sites as plain array of ID strings for MUI multiple select
    let siteChoices = sites
      .filter((siteOption) =>
        data?.sites?.some((s) => (s._id || s?.id || s) === siteOption.value)
      )
      .map((siteOption) => siteOption.value);

    setPerson(prevState => ({
      ...prevState,
      name: data?.name,
      email: data?.email,
      phone: data?.phone?.toString(),
      countryId: data?.countryId?._id,
      cityId: data?.cityId?._id,
      address: data?.address,
      role: data?.roleId?._id,
      company: data?.company?._id,
      site: siteChoices,        // ✅ array of ID strings
      mLicense: data?.mLicense,
      nameError: false,
      emailError: false,
      passwordError: false,
      countryIdError: false,
      cityIdError: false,
      addressError: false,
      roleError: false
    }));

    getCities(data?.countryId?._id);
    setAction('edit');
    setOpen(true);
  };

  const deleteVendor = (id) => {
    setEditId(id);
    clearAll();
    setShow(true);
  };

  const clearAll = () => {
    setPerson({
      name: '',
      email: '',
      phone: '',
      countryId: '',
      cityId: '',
      address: '',
      role: '',
      company: '',
      site: [],
      mLicense: '',
      nameError: false,
      emailError: false,
      phoneError: false,
      companyError: false,
      countryIdError: false,
      cityIdError: false,
      addressError: false,
      roleError: false,
      siteError: false
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleShowClose = () => {
    setShow(false);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      setSelectedFile(file);
      setMessage('');
    } else {
      setSelectedFile(null);
      setMessage('Please select a valid PDF file.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setPerson(prevState => ({
      ...prevState,
      nameError: false,
      emailError: false,
      phoneError: false,
      countryIdError: false,
      cityIdError: false,
      addressError: false,
      roleError: false,
      companyError: false,
      siteError: false
    }));

    if (validation(null, 'Name', person.name)) {
      setPerson(prevState => ({ ...prevState, nameError: true }));
      return;
    } else if (validation('email', 'Email', person.email)) {
      setPerson(prevState => ({ ...prevState, emailError: true }));
      return;
    } else if (validation('phone', 'Phone', person.phone)) {
      setPerson(prevState => ({ ...prevState, phoneError: true }));
      return;
    } else if (validation('empty', 'Country', person.countryId)) {
      setPerson(prevState => ({ ...prevState, countryIdError: true }));
      return;
    } else if (validation('empty', 'City', person.cityId)) {
      setPerson(prevState => ({ ...prevState, cityIdError: true }));
      return;
    } else if (validation('long', 'Address', person.address)) {
      setPerson(prevState => ({ ...prevState, addressError: true }));
      return;
    }

    // ✅ Fix #4: person.site is already plain array of IDs
    const ids = person.site;

    const formData = new FormData();
    formData.append("name", person?.name);
    formData.append("email", person?.email);
    formData.append("phone", person?.phone);
    // ✅ Fix #5: fallback to person.company if companyId from localStorage is undefined
    formData.append("companyId", companyId || person?.company);
    formData.append("company", companyId || person?.company);
    formData.append("countryId", person?.countryId);
    // ✅ Fix #1: append each site ID individually as proper array
    ids.forEach((id) => formData.append("sites[]", id));
    formData.append("cityId", person?.cityId);
    formData.append("address", person?.address);
    formData.append("mLicense", person?.mLicense);
    if (selectedFile) {
      formData.append('picture', selectedFile);
    }

    // ✅ Fix #3 & #4: try/finally ensures loader always resets
    if (action === 'add') {
      setLoader(true);
      try {
        let data = await postAPI('/vendors', formData);
        if (data) {
          // toast.success("Vendor added successfully", toastObj);
          getVendors();
          setOpen(false);
          setShow(false);
        } else {
          toast.error("Failed to add vendor", toastObj);
        }
      } finally {
        setLoader(false);
      }
    } else if (action === 'edit') {
      setLoader(true);
      try {
        let data = await patchAPI(`/vendors/${editId}`, formData);
        if (data) {
          // toast.success("Vendor updated successfully", toastObj);
          getVendors();
          setOpen(false);
        } else {
          toast.error("Failed to update vendor", toastObj);
        }
      } finally {
        setLoader(false);
      }
    }
  };

  const handleDelete = async () => {
    setLoader(true);
    let process = await deleteAPI(`/vendors/${editId}`);
    setLoader(false);
    if (process) {
      getVendors();
      setShow(false);
    }
  };

  const handleUpload = () => {
    if (!selectedFile) {
      setMessage('Please select a PDF file before submitting');
      return;
    }
  };

  return (
    <Box sx={{ height: "inherit" }}>
      <Loader loader={loader} />
      <PageTitle title="Vendors" subTitle="" />
      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="flex-end"
        sx={{ mx: 2 }}
      >
        {(showBothButtons || canAdd) && (
          <Button
            variant="contained"
            style={{ backgroundColor: "#75859D" }}
            sx={{ height: 50 }}
            onClick={addVendor}
          >
            <AddCircleIcon /> &nbsp; &nbsp;
            Add Vendor
          </Button>
        )}
      </Box>

      <Box display="flex" sx={{ my: "2rem" }}>
        <TableContainer component={Paper} sx={{ mx: "0.8rem" }}>
          <Table
            sx={{ minWidth: "auto" }}
            aria-label="custom pagination table"
            className="responsive-table"
          >
            <TableHead>
              <TableRow className="table-header" align="center">
                <TableCell align="left" component="th" sx={tableHeader}>Vendor</TableCell>
                <TableCell align="left" component="th" sx={tableHeader}>Email</TableCell>
                <TableCell align="center" component="th" sx={tableHeader}>Country</TableCell>
                <TableCell align="center" component="th" sx={tableHeader}>City</TableCell>
                <TableCell align="center" component="th" sx={tableHeader}>Phone</TableCell>
                <TableCell align="center" component="th" sx={tableHeader}>Master License</TableCell>
                <TableCell align="center" component="th" sx={tableHeader}>Address</TableCell>
                <TableCell align="center" component="th" sx={tableHeader}>Created At</TableCell>
                <TableCell align="center" component="th" sx={tableHeader}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vendors.slice(page * perPage, page * perPage + perPage).map((item, index) => (
                <TableRow key={index}>
                  <TableCell align="left" sx={tableData}>
                    {/* ✅ Fix #7: _id || id used safely */}
                    <Link underline="none" href={`/vendor/${item._id || item.id}/clients`} className="pointer">
                      {item?.name}
                    </Link>
                  </TableCell>
                  <TableCell align="left" sx={tableData}>{item?.email}</TableCell>
                  <TableCell align="center" sx={tableData}>{item?.countryId?.name}</TableCell>
                  <TableCell align="center" sx={tableData}>{item?.cityId?.name}</TableCell>
                  <TableCell align="center" sx={tableData}>{item?.phone}</TableCell>
                  <TableCell align="center" sx={tableData}>{item?.mLicense}</TableCell>
                  <TableCell align="center" sx={tableData} className="address-width">{item?.address}</TableCell>
                  <TableCell align="center" sx={tableData}>{formatDate(item?.createdAt)}</TableCell>
                  <TableCell align="center" className="action-div" sx={{ textAlign: 'center' }}>
                    {(showBothButtons || canEdit) && (
                      <Button
                        size="small"
                        className="btn-div"
                        variant="outlined"
                        color="info"
                        onClick={(e) => editVendor(e, item?._id || item?.id)}
                      >
                        <EditIcon />
                      </Button>
                    )}
                    {(showBothButtons || canDelete) && (
                      <Button
                        size="small"
                        className="btn-div"
                        variant="outlined"
                        color="error"
                        onClick={() => deleteVendor(item?._id || item?.id)}
                      >
                        <DeleteIcon />
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
              {vendors.length === 0 && <EmptyTable colSpan={9} />}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  align="right"
                  rowsPerPageOptions={perPages}
                  colSpan={9}
                  count={vendors.length}
                  rowsPerPage={perPage}
                  page={page}
                  SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Box>

      {/* Add / Edit Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth={true}>
        <DialogTitle sx={{ mb: 4, textAlign: "center" }}>
          {action === 'add' ? 'Add' : 'Edit'} Vendor
        </DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { my: 2, width: '100%' } }}
            noValidate
            autoComplete="off"
          >
            <FormControl sx={{ minWidth: '97%', mx: 0, px: 0 }}>
              <TextField
                id="name"
                label="Name *"
                variant="outlined"
                type="text"
                value={person.name}
                error={person.nameError}
                onChange={(e) => setPerson(prevState => ({ ...prevState, name: e.target.value }))}
                fullWidth
                sx={{ m: 0 }}
              />
            </FormControl>

            <FormControl sx={{ minWidth: '97%' }}>
              <TextField
                id="email"
                label="Email *"
                variant="outlined"
                type="email"
                value={person.email}
                error={person.emailError}
                onChange={(e) => setPerson(prevState => ({ ...prevState, email: e.target.value }))}
                fullWidth
              />
            </FormControl>

            {/* ✅ MUI multiple select — react-select removed */}
            <FormControl sx={{ minWidth: '97%', mt: 2 }}>
              <InputLabel id="sites-label">Sites</InputLabel>
              <Choice
                labelId="sites-label"
                id="sites"
                multiple
                value={person.site}
                label="Sites"
                error={person.siteError}
                onChange={(e) => {
                  setPerson(prevState => ({
                    ...prevState,
                    site: e.target.value,  // array of selected ID strings
                  }));
                }}
                renderValue={(selected) =>
                  selected
                    .map((id) => sites.find((s) => s.value === id)?.label || id)
                    .join(', ')
                }
              >
                {sites.map((item, index) => (
                  <MenuItem value={item.value} key={index}>
                    {item.label}
                  </MenuItem>
                ))}
              </Choice>
              {person.siteError && (
                <span style={{ color: 'red', fontSize: 12, marginTop: 4 }}>
                  Site is required
                </span>
              )}
            </FormControl>

            <FormControl sx={{ minWidth: '97%' }}>
              <TextField
                id="phone"
                label="Phone *"
                variant="outlined"
                type="number"
                value={person.phone}
                error={person.phoneError}
                onChange={(e) => setPerson(prevState => ({ ...prevState, phone: e.target.value }))}
                fullWidth
              />
            </FormControl>

            <FormControl sx={{ minWidth: '97%', mx: 0, px: 0 }}>
              <TextField
                id="mlicense"
                label="Master License"
                variant="outlined"
                type="text"
                value={person.mLicense}
                onChange={(e) => setPerson(prevState => ({ ...prevState, mLicense: e.target.value }))}
                onInput={(e) => {
                  e.target.value = e.target.value.toString().slice(0, 20);
                }}
                fullWidth
                sx={{ m: 0 }}
              />
            </FormControl>

            <FormControl sx={{ minWidth: '97%', mt: 2 }}>
              <InputLabel id="country-label">Country *</InputLabel>
              <Choice
                labelId="country-label"
                id="country"
                value={person.countryId}
                label="Country *"
                error={person.countryIdError}
                onChange={(e) => {
                  setPerson(prevState => ({
                    ...prevState,
                    countryId: e.target.value,
                    cityId: '',          // reset city when country changes
                  }));
                  getCities(e.target.value);
                }}
              >
                {countries.map((item, index) => (
                  <MenuItem value={item._id} key={index}>{item.name}</MenuItem>
                ))}
              </Choice>
            </FormControl>

            <FormControl sx={{ minWidth: '97%', mt: 4 }}>
              <InputLabel id="city-label">City *</InputLabel>
              <Choice
                labelId="city-label"
                id="city"
                value={person.cityId}
                error={person.cityIdError}
                label="City *"
                onChange={(e) => setPerson(prevState => ({ ...prevState, cityId: e.target.value }))}
              >
                {cities.map((item, index) => (
                  <MenuItem value={item._id} key={index}>{item.name}</MenuItem>
                ))}
              </Choice>
            </FormControl>

            <FormControl sx={{ minWidth: '97%', mt: 2 }}>
              <TextField
                id="address"
                label="Address *"
                variant="outlined"
                type="text"
                error={person.addressError}
                value={person.address}
                multiline={true}
                rows={3}
                onChange={(e) => setPerson(prevState => ({ ...prevState, address: e.target.value }))}
                fullWidth
              />
            </FormControl>

            <Box sx={{ maxWidth: 400, margin: '0 auto', padding: 2 }}>
              <Typography variant="subtitle2" component="h6" gutterBottom>
                Upload Casual Shift Terms and Conditions
              </Typography>
              <Button
                variant="contained"
                component="label"
                startIcon={<UploadFileIcon />}
                sx={{ marginBottom: 2 }}
              >
                Choose File
                <input
                  type="file"
                  accept="application/pdf"
                  hidden
                  onChange={handleFileChange}
                />
              </Button>
              {selectedFile && (
                <Typography variant="body2" color="text.secondary">
                  Selected File: {selectedFile.name}
                </Typography>
              )}
              {message && (
                <Typography
                  variant="body2"
                  color={message.includes('successfully') ? 'green' : 'red'}
                >
                  {message}
                </Typography>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions sx={{ mb: 2, mx: 4 }}>
          <Button onClick={handleSubmit} variant="contained">
            {action === 'add' ? 'Submit' : 'Update'}
          </Button>
          <Button onClick={handleClose} variant="outlined">Cancel</Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={show} onClose={handleShowClose} fullWidth={true}>
        <DialogTitle sx={{ mb: 4, textAlign: "center" }}>Delete Vendor</DialogTitle>
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { my: 2, width: '100%' } }}
            noValidate
            autoComplete="off"
          >
            <h3 style={{ textAlign: 'center', fontWeight: 'bold' }}>
              Do you want to delete this vendor?
            </h3>
          </Box>
        </DialogContent>
        <DialogActions sx={{ mb: 2, mx: 4 }}>
          <Button onClick={handleDelete} variant="contained" color="error">Delete</Button>
          <Button onClick={handleShowClose} variant="outlined">Cancel</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
